import React from 'react';
import {MdWarning} from 'react-icons/md';
import {
	Button,
	Icon,
	Modal,
	ModalBody,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Stack,
	Text,
} from 'components/ui/chakra';

interface MedicalEmergencyModalProps {
	isOpen: boolean;
	onConfirm: () => void;
	onClose: () => void;
}

const MedicalEmergencyModal = ({isOpen, onConfirm, onClose}: MedicalEmergencyModalProps) => (
	<Modal size='xs' isOpen={isOpen} onClose={onClose} isCentered>
		<ModalOverlay />
		<ModalContent>
			<ModalHeader px={8} pt={8} pb={4} textAlign='center' color='gray.900'>
				<Icon
					as={MdWarning}
					boxSize={6}
					color='red.500'
					mr={2}
					verticalAlign='text-bottom'
				/>
				Is this a medical emergency?
			</ModalHeader>
			<ModalBody px={8} pt={0} pb={8}>
				<Text color='subtleText' textAlign='center' maxW='20rem' mx='auto'>
					This application is not designed for medical emergencies. If you believe you are
					having a medical emergency, please call 911 or visit the emergency room.
				</Text>

				<Stack spacing={3} mt={5} w='full'>
					<Button onClick={onConfirm} w='full' minH='3.5rem'>
						This is not a medical emergency
					</Button>
					<Button intent='tertiary' onClick={onClose} w='full' minH='3.5rem'>
						Close
					</Button>
				</Stack>
			</ModalBody>
		</ModalContent>
	</Modal>
);

export default MedicalEmergencyModal;
